import { Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";

// M — Final call to action.
export const FinalCta = () => (
  <section data-testid="final-cta-section" className="on-dark relative overflow-hidden bg-[var(--navy)] py-24 text-white sm:py-32">
    <div className="pointer-events-none absolute -right-40 -top-40 h-[30rem] w-[30rem] rounded-full bg-[#0440ff]/15 blur-[120px]" />
    <div className="wrap max-w-4xl">
      <Reveal>
        <p className="eyebrow !text-white/70">
          <span className="no">10</span>
          <span className="rule" />
          YOUR NEXT PROJECT
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="headline mt-6 text-4xl sm:text-5xl lg:text-[3.8rem]">
          Bring us the part you’re <span className="font-serif-i text-[#9db8ff]">thinking hardest about.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg [text-wrap:pretty]">
          A new design. A production requirement. A component you’re evaluating for a different manufacturing source.
        </p>
        <p className="mt-3 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg [text-wrap:pretty]">
          Tell us what you need made, what matters most, and where you need answers.
        </p>
      </Reveal>
      <Reveal delay={0.24}>
        <div className="mt-9 flex flex-wrap items-center gap-3.5">
          <button
            type="button"
            data-testid="final-quote-button"
            className="btn btn-light"
            onClick={() => { const el = document.getElementById("contact"); if (window.__lenis && el) window.__lenis.scrollTo(el, { offset: -90 }); else el?.scrollIntoView({ behavior: "smooth" }); }}
          >
            Request a Quote
          </button>
          <a href="tel:+19704827676" data-testid="final-call-button" className="btn btn-ghost">
            <Phone className="h-4 w-4" /> Call (970) 482-7676
          </a>
        </div>
      </Reveal>
      <Reveal delay={0.3}>
        <p className="mt-8 max-w-2xl text-[14.5px] leading-relaxed text-white/60 [text-wrap:pretty]">
          Have a drawing or model ready? Ask our team about the appropriate way to share your project files.
        </p>
      </Reveal>
    </div>
  </section>
);
